export const mapIds = <T extends { id: string }>(objects: T[]): string[] => {
  return objects.map(({ id }) => id);
};
